import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    videoId: String,
    height: { type: Number, default: 390 },
    width: { type: Number, default: 640 },
    start: { type: Number, default: 0 },
    end: { type: Number, default: 0 },
  };
  static targets = ["player", "overlay", "interactionBlocker"];

  connect() {
    console.log("Youtube controller connected");
    this.insertYouTubeScript();
    if (window._stimulusYouTubeAPIReady) {
      this.initializePlayer();
    }
  }

  initializePlayer() {
    // get viewport height and width
    const viewportHeight = window.innerHeight;
    const viewportWidth = window.innerWidth;
    this.player = new window.YT.Player(this.playerTarget, {
      height: viewportHeight,
      width: viewportWidth,
      videoId: this.videoIdValue,
      playerVars: {
        autoplay: 1,
        start: this.startValue,
        end: this.endValue,
        controls: 0,
        disablekb: 1,
        mute: 1,
      },
      events: {
        onStateChange: this.onPlayerStateChange.bind(this),
        onReady: this.onPlayerReady.bind(this),
      },
    });
  }

  onPlayerReady(stateEvent) {
    console.log("Player ready");
    // You can add any initialization logic here
    // if the video is at the end, stop the video
    if (stateEvent.data === window.YT.PlayerState.ENDED) {
      console.log("Video ended");
    }
  }

  onPlayerStateChange(stateEvent) {
    console.log("Player state changed:", stateEvent.data);
    // Handle player state changes (playing, paused, ended, etc.)
    if (stateEvent.data === window.YT.PlayerState.ENDED) {
      console.log("Video ended");
      this.playerTarget.style.display = "none";
      this.overlayTarget.classList.remove("hidden");
      this.interactionBlockerTarget.style.display = "none";
    }
  }

  restartVideo() {
    this.player.seekTo(this.startValue);
    this.player.playVideo();
    this.playerTarget.style.display = "block";
    this.overlayTarget.classList.add("hidden");
    this.interactionBlockerTarget.style.display = "block";
  }

  insertYouTubeScript() {
    if (document.getElementById("youtube-iframe-api")) return;

    const tag = document.createElement("script");
    tag.id = "youtube-iframe-api";
    tag.src = "https://www.youtube.com/iframe_api";

    // Set up the global callback
    window.onYouTubeIframeAPIReady = () => {
      window._stimulusYouTubeAPIReady = true;
      this.initializePlayer();
    };

    const firstScriptTag = document.getElementsByTagName("script")[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
  }
}
